import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: '0 0 0 auto',
      '& :hover': {
        cursor: 'pointer',
      },
    },
    typography: {
      padding: theme.spacing(2),
    },
    icon: {
      marginRight: '20px',
    },
    sharingText: {
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontSize: '14px',
    },
    linkContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '5px',
      margin: '5px',
      alignItems: 'center',
      textDecoration: 'none',
      '& :hover': {
        cursor: 'pointer',
      },
    },
  }),
)

export default function SharePopover({ currentUrl }: { currentUrl: string }) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const [openedSnackBar, setOpenedSnackBar] = React.useState<boolean>(false)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl)
    setOpenedSnackBar(true)
  }

  const handleCloseSnackbar = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setOpenedSnackBar(false)
  }

  return (
    <div className={classes.root}>
      <span aria-describedby={id} onClick={handleClick}>
        <img src="/svg/share.svg" />
      </span>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div onClick={copyToClipboard} className={classes.linkContainer}>
          <img width={25} height={25} className={classes.icon} src={`/svg/link.svg`} alt="link" />
          <Typography className={classes.sharingText}>Copy link</Typography>
        </div>
        <a
          href={`https://twitter.com/intent/tweet?url=${currentUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          title="Twitter"
          className={classes.linkContainer}
        >
          <img
            width={25}
            height={25}
            className={classes.icon}
            src={`/svg/twitter.svg`}
            alt="Twitter logo"
          />
          <Typography className={classes.sharingText}>Twitter</Typography>
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          title="LinkedIn"
          className={classes.linkContainer}
        >
          <img
            width={25}
            height={25}
            className={classes.icon}
            src={`/svg/linkedin.svg`}
            alt="LinkedIn logo"
          />
          <Typography className={classes.sharingText}>LinkedIn</Typography>
        </a>
      </Popover>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={openedSnackBar}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Copied to clipboard!"
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </div>
  )
}
